<!-- 邮件管理页面邮件预览页 -->
<template>
    <div class="email-preview" :style="$parent.$parent.emails.length>1?'cursor: pointer;':''">
        <!-- 头部信息 -->
        <div class="email-preview-head" @click="haveShowMain()">
            <div class="personal"></div>
            <div class="email-preview-user">
                <div class="email-preview-from">{{email.from|fromFilter}}</div>
                <div class="email-preview-snippet" v-if="!(isShowMain&&!isLoadingMain)" v-html="email.snippet"></div>
                <div class="email-preview-to" v-if="isShowMain&&!isLoadingMain">
                    <div style="float:left;">{{$t('language.emailExploer.to')+": "+emailDetail.to}}</div>
                    <div class="icon-util down-position email-preview-user-down" @mouseover="isUserDetail=true" @mouseleave="isUserDetail=false">
                        <div class="email-preview-user-detail" v-if="isUserDetail">
                            <el-scrollbar style='height:100%;'>
                                <div style="display: table;">
                                    <div class="user-detail-item">
                                        <div class="user-detail-item-head">{{$t('language.emailExploer.from')}}:</div>
                                        <div class="user-detail-item-msg">{{emailDetail.from}}</div>
                                    </div>
                                    <div class="user-detail-item" :key="index" v-for="(toUser,index) in emailDetail.toUsers">
                                        <div class="user-detail-item-head"><span v-if="index==0">{{$t('language.emailExploer.to')}}:</span></div>
                                        <div class="user-detail-item-msg">{{toUser}}<span v-if="index!=emailDetail.toUsers.length-1">,</span></div>
                                    </div>
                                    <div class="user-detail-item" :key="index" v-for="(ccUser,index) in emailDetail.ccUsers">
                                        <div class="user-detail-item-head"><span v-if="index==0">{{$t('language.emailExploer.cc')}}:</span></div>
                                        <div class="user-detail-item-msg">{{ccUser}}<span v-if="index!=emailDetail.ccUsers.length-1">,</span></div>
                                    </div>
                                </div>
                            </el-scrollbar>
                        </div>
                    </div>
                </div>
            </div>
            <div class="email-preview-date" v-if="$route.query.cloudType=='gmail'">{{email.date}}</div>
            <div class="email-preview-date" v-else>{{email.date|transferTime}}</div>
        </div>
        <!-- 信息 -->
        <div class="email-preview-body" v-if="isShowMain" v-loading="isLoadingMain">
            <!-- 正文 -->
            <div class="email-preview-main" v-if="emailDetail">
                <email-text ref="emailText" :text="emailItem.text"></email-text>
            </div>
            <!-- 附件 -->
            <div class="email-preview-appendixs" v-if="emailItem&&attachmentArray.length>0">
                <hr>
                <div class="email-preview-appendixs-title">{{attachmentArray.length+" attachment(s)"}}</div>
                <div class="email-preview-appendix" :key="index" v-for="(appendix,index) in attachmentArray">
                    <div class="appendix-img"></div>
                    <div class="appendix-msg">
                        <div>{{appendix.attachmentName|ellipsis}}{{appendix.name|ellipsis}}</div>
                        <div style="color:#999999;">{{appendix.attachmentSize|formatByte}}{{appendix.size|formatByte}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
import emailText from "./email_text";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    props: ["email"],
    components: {
        emailText
    },
    data() {
        return {
            isShowMain: false,//是否展示正文详情
            isLoadingMain: true,//是否显示正文加载中
            isUserDetail: false,//是否展示用户详情下拉框
            emailDetail: null,
            emailItem: {},//邮件内容
            attachmentArray: [],//附件
            errorNum: 0
        }
    },
    created() {
        //最后一封邮件默认展开
        if(this.email.isLast){
            this.isShowMain = true;
            if(this.email.emailDetail){
                //如果有详情
                this.emailDetail = this.email
            }
            if(!this.emailDetail){
                this.getEmail();
            }else {
                this.errorNum = 0;
                this.isLoadingMain = false;
                this.setData();
            }
        }
    },
    methods: {
        haveShowMain(){
            //如果只有一封邮件，固定展开
            if(this.$parent.$parent.emails.length<2){
                return;
            }
            if(this.isShowMain){
                this.isShowMain = false;
            }else{
                this.isShowMain = true;
                if(!this.emailDetail){
                    this.getEmail();
                }
            }
            this.errorNum = 0;
        },
        //获取邮件信息
        getEmail() {
            let data = new cloudExploerUtils.emaillistData(this.email.id, commonUtils.getUser().id, this.email.driveId,"message", 0,null,null);
            this.Utils.doCloudEmailRequest("list",data).then(res => {
                if(res.status == 200){
                    this.errorNum = 0;
                    this.isLoadingMain = false;
                    //处理正文信息
                    if(res.items.length>0){
                        this.emailDetail = res.items[0];
                        this.setData();
                    }
                }else{
                    if(this.isShowMain&&this.errorNum<6){
                        //如果失败后仍然是打开的，则需要自动重试
                        setTimeout(() => {
                            this.errorNum++;
                            this.getEmail();
                        }, 3000);
                    }
                }
            });
        },
        setData() {
            if(this.emailDetail.to){
                this.emailDetail.toUsers = this.emailDetail.to.split(",");
            }else{
                this.emailDetail.toUsers = [];
            }
            if(this.emailDetail.cc){
                this.emailDetail.ccUsers = this.emailDetail.cc.split(",");
            }else{
                this.emailDetail.ccUsers = [];
            }
            if(this.emailDetail.cloudEmailAddress){
                //如果存在本人
                let toUserList = this.emailDetail.toUsers;
                for (let i = 0; i < toUserList.length; i++) {
                    const item = toUserList[i];
                    if(item.lastIndexOf(this.emailDetail.cloudEmailAddress)>0){
                        toUserList[i] = this.$t('language.common.me');
                    }
                }
                this.emailDetail.to = toUserList.join(",");
            }
            if(this.emailDetail.emailDetail){
                this.emailItem = this.emailDetail.emailDetail;
                if(this.emailItem.attachmentArray){
                    this.attachmentArray = this.emailItem.attachmentArray;
                }
            }
            //如果是外部的附件，则优先使用外部附件
            if(this.emailDetail.attachmentArray){
                this.attachmentArray = this.emailDetail.attachmentArray;
            }
        }
    },
    filters: {
        fromFilter (value) {
            if (!value) return '';
            let filterIndex = value.lastIndexOf(' <');
            if(filterIndex>0){
                let more = value.lastIndexOf(',');
                let str;
                if(more>0){
                    //多个
                    let vals = value.split(',');
                    let newVakls = [];
                    vals.forEach(v => {
                    let fIndex = v.lastIndexOf(' <');
                    if(fIndex>0){
                        let valsStr = v.substring(0,fIndex);
                        newVakls.push(valsStr);
                    }else{
                        newVakls.push(v);
                    }
                    });
                    str = newVakls.join(',');
                }else{
                    str = value.substring(0,filterIndex);
                }
                return str;
            }else {
                return value;
            }
        },
        ellipsis (value) {
            let subStr;
            if (!value) return '';
            if (value.length > 40) {
                subStr = value.slice(0, 40) + '...';
            } else {
                subStr = value;
            }
            return subStr;
        },
    }
}
</script>
<style scoped>
.email-preview {
    margin-bottom: 20px;/*no*/
}

.email-preview-head {
    height: 50px;/*no*/
    font-size: 14px;/*no*/
    font-weight: 400;
    color: #6F7886;
    position: relative;
}

.email-preview-user {
    line-height: 24px;/*no*/
    float: left;
    display: flex;
    flex-direction: column;
    width: calc(100% - 72px);/*no*/
}

.email-preview-from {
    min-height: 30px;/*no*/
    min-width: 20px;/*no*/
    font-size: 16px;/*no*/
    font-weight: bold;
    color: #000000;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 50%;
}

.email-preview-snippet {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 85%;
}

.email-preview-date {
    position: absolute;
    right: 30px;/*no*/
}

.email-preview-body {
    min-height: 200px;/*no*/
}

.email-preview-main{
    padding: 20px 72px 0;/*no*/
}

.personal {
    width: 48px;/*no*/
    height: 48px;/*no*/
    float: left;
    margin-right: 24px;/*no*/
}

.icon-util {
    float: right;
}

.down-position {
    width: 20px;/*no*/
    height: 20px;/*no*/
    background-position: -579px -201px;/*no*/
}

.email-preview-user-down {
    cursor: pointer;
    position: relative;
    float: left;
}

.email-preview-user-detail {
    width: max-content;
    min-width: 65px;/*no*/
    min-height: 34px;/*no*/
    max-height: 300px;/*no*/
    border: 1px solid #8A96E3;/*no*/
    background: #fff;
    position: absolute;
    top: 20px;/*no*/
    left: 10px;/*no*/
    z-index: 1;
}

.user-detail-item {
    font-size: 14px;/*no*/
    font-family: ArialMT;
    line-height: 34px;/*no*/
    color: #6F7886;
    padding-right: 10px;/*no*/
    display: table-row;
}

.user-detail-item:hover {
    background: #D9E7FF;
}

.user-detail-item-head {
    text-align: right;
    padding-right: 8px;/*no*/
    padding-left: 15px;/*no*/
    display: table-cell;
}

.user-detail-item-msg {
    display: table-cell;
    padding-right: 15px;/*no*/
}

hr {
    background: #DDDDDD;
    border: 0;
    height: 1px;/*no*/
}

.email-preview-appendixs {
    width: 50%;
}

.email-preview-appendixs-title {
    font-size: 16px;/*no*/
    font-family: Arial;
    font-weight: bold;
    line-height: 17px;/*no*/
    color: #333333;
}

.email-preview-appendix {
    height: 36px;/*no*/
    display: flex;
    font-size: 14px;/*no*/
    font-family: Arial;
    font-weight: 400;
    line-height: 18px;/*no*/
    margin-top: 12px;/*no*/
}

.appendix-img {
    margin: 2px 14px;/*no*/
    width: 32px;/*no*/
    height: 32px;/*no*/
    background-image: url("../../assets/images/vectorImg/icon_file_32px.svg");
    
}

</style>


// WEBPACK FOOTER //
// src/components/preview/email_exploer.vue